import useMarkInboundEmailAsRead from '@/api/mutations/inbound-emails/useMarkInboundEmailAsRead';
import { MarkInboundEmailAsReadMutation } from '@/gql/graphql';
import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { createOptimisticMutationOptions } from './createOptimisticMutation';
import {
  applyDetailOptimisticMarkAsRead,
  applyOptimisticMarkAsRead,
} from './optimisticUpdates';

const useOptimisticMarkInboundEmailAsRead = (
  options?: UseMutationOptions<
    MarkInboundEmailAsReadMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  const queryClient = useQueryClient();

  const optimistic = createOptimisticMutationOptions(
    queryClient,
    {
      applyToInbox: (data, vars) => applyOptimisticMarkAsRead(data, vars),
      applyToDetail: (data) => applyDetailOptimisticMarkAsRead(data),
      tracksUnreadCount: true,
    },
    options
  );

  return useMarkInboundEmailAsRead({ ...options, ...optimistic });
};

export default useOptimisticMarkInboundEmailAsRead;
